import * as AccessoriesRequests from './accessoriesRequests';

const Actions = {
  ...AccessoriesRequests,
};

export default Actions;
